"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMediaContact = function IconMediaContact(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M39.27 9H20.73A4.73 4.73 0 0 0 16 13.705v9.535a4.73 4.73 0 0 0 1.372 3.361l.182.174A4.73 4.73 0 0 0 20.73 28h8.851l4.14 4.207L37.849 28h1.421A4.73 4.73 0 0 0 44 23.245V13.71A4.73 4.73 0 0 0 39.27 9m-18.54 2h18.54A2.73 2.73 0 0 1 42 13.715v9.535A2.734 2.734 0 0 1 39.27 26h-2.26l-3.291 3.353-3.3-3.353H20.73A2.73 2.73 0 0 1 18 23.248V13.71A2.73 2.73 0 0 1 20.73 11M14 24v-2H7.29l-.236.006a4.33 4.33 0 0 0-2.74 1.177A4.11 4.11 0 0 0 3 26.147V33.8l.014.242a4.13 4.13 0 0 0 1.307 2.692l.166.16A4.3 4.3 0 0 0 7.263 38l1.261-.001 3.686 3.574 2.336-2.265 1.357-1.309L23.71 38l.245-.013a4.34 4.34 0 0 0 2.76-1.288l.154-.15A4.1 4.1 0 0 0 28 33.762L28 30h-2v3.75l-.011.189c-.053.5-.29.976-.668 1.327a2.37 2.37 0 0 1-1.638.734h-8.586l-1.94 1.87-.948.917L9.335 36H7.29l-.192-.014a2.33 2.33 0 0 1-1.383-.685A2.16 2.16 0 0 1 5 33.77V26.16l.011-.189c.053-.5.29-.976.668-1.327A2.34 2.34 0 0 1 7.29 24zm2 4.97v1H8v-1zm7 4v-1H8v1zm15-13v1H21v-1zm1-3v-1H21v1z",
    clipRule: "evenodd"
  })));
};

export { IconMediaContact, IconMediaContact as default };
